export default __webpack_public_path__ + "static/media/doritos.f55183e3.svg";